   $( document ).ready(function() {
    var elements = document.querySelectorAll(".about-flowers");

    // Intersection observer
    var observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
                entry.target.classList.add("animate");
            } else {
                entry.target.classList.remove("animate");
            }
        });
    });
    elements.forEach((el) => {
        observer.observe(el);
    });
});